import React from 'react';
import { Link } from 'react-router-dom';

import './style.scss';
import { EntityId } from "@reduxjs/toolkit";
import NavDropdown from "../NavDropdown";

interface itemInterface {
  id: number;
  name?: string;
  title?: string;
  url: string;
  parent_id?: number | null;
  subcategories?: number[];
}

export interface parentInterface {
  name?: string;
  url: string;
  isActive?: boolean | Function;
}

interface itemsInterface {
  [key: string]: itemInterface | undefined
}

interface propsInterface {
  items: itemsInterface | undefined;
  itemIds: EntityId[] | undefined;
  activeId?: number | undefined;
  parent?: parentInterface;
}

const NavBarTwo = ({ parent, items, itemIds, activeId }: propsInterface) => {
  if (!items || !itemIds) {
    return null;
  }

  function name(item: any) {
    return item.name || item.title;
  }

  const RenderWithSubcategories = ({ item }: any) => {
    let itemClass = 'v-item o-dropdown';
    if (activeId === item.id || (activeId && item.subcategories.includes(activeId))) {
      itemClass += ' active';
    }

    return(
      <NavDropdown
        items={items}
        itemIds={item.subcategories}
        activeId={activeId}
        placement='bottomLeft'
        parent={{ ...item, name: 'All' }}
        popoverProps={{
          placement: 'bottomLeft',
          overlayClassName: 'v-navbar-two-dropdown'
        }}
      >
        <span className={itemClass}>
          {name(item)}
        </span>
      </NavDropdown>
    );
  }

  const RenderItem = ({ item }: any) => {
    let itemClass = 'v-item';
    if (activeId === item.id || (item.isActive && item.isActive())) {
      itemClass += ' active';
    }

    return(
      <Link to={item.url} className={itemClass}>
        {name(item)}
      </Link>
    )
  }

  return (
    <div className='v-navbar-two'>
      <div className='v-nav'>
        {parent && <RenderItem key={parent.name} item={parent} className='o-parent' />}

        {
          itemIds.map(id => {
            const item = items[id];

            if (!item) {
              return null;
            } else if (Array.isArray(item.subcategories) && item.subcategories.length) {
              return <RenderWithSubcategories key={id} item={item} />
            } else {
              return <RenderItem key={id} item={item} />
            }
          })
        }
      </div>
    </div>
  );
}

export default NavBarTwo;
